export const getFrequencyEditData = (
  list: string,
  intervalUnit: string,
  includesThreeMonthPouch?: boolean
) => {
  const periods = list;
  let intervals = [];
  if (periods && !includesThreeMonthPouch) {
    intervals = periods.split(',').map((item: string) => item.trim());
  } else {
    intervals = ['15', '30', '45', '60', '90'];
  }
  const unit = intervalUnit || 'day';

  return { intervals, unit };
};
